<template>
  <app-modal width="800px" name='import-invoice-modal' ref="modal" :title="title" :okText="$t('app.confirm')"
    :submit-on-enter="false" :is-submitting="uploadStatus.uploading" @before-open="beforeOpen"
    @before-close="beforeClose" @on-ok="onOk">
    <div class="row">
      <div class="col-md-12 invoice-form pr-0">
        <h6>{{ $t("invoice.uploadInvoices") }}</h6>
        <app-form ref="form" @on-submit="onSubmit" :schema="schema" :data="formModel">
        </app-form>
      </div>
      <div class="col-md-12 pr-0">
        <h6>{{ $t("upload.templateFile") }}</h6>
        <div class="row pl-3" style="gap: 24px">
          <div class="bg-primary rounded-xl px-4 py-3 col-md-10 d-flex flex-row align-items-center">
            <img height="16px" class="logo" src="images/excel-icon.svg" alt="PVS Logo">
            <span class="ml-2">{{ $t("upload.template") }}</span>
          </div>
          <a class="col-md-1 btn bg-primary rounded-xl btn-download"
            href="files/Danh_sach_hoa_don.xlsx" download>
            <img height="20px" class="logo" src="images/import-icon.svg" alt="PVS Logo">
          </a>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/index';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
// import ToastUtils from '@/utils/toast';

const formSchema = context => ({
  document: {
    inputType: 'file',
    multiple: true,
    type: 'input',
    draggable: true,
    accept: '.xls,.xlsx',
    validation: 'required',
    action: context.$t('upload.action'),
    notice: context.$t('upload.notice'),
  },
});

export default {
  name: 'ImportInvoiceModal',
  components: {
    AppModal,
    AppForm,
  },
  props: {
    locale: {
      type: String,
      default: 'vi',
    },
  },
  data() {
    return {
      title: this.$t('reconciliation.uploadListInvoiceReconciliation'),
      schema: [],
      formModel: {
        document: null,
      },
      uploadStatus: {
        count: 0,
        uploading: false,
        percentCompleted: 0,
      },
    };
  },
  methods: {
    onOk() {
      this.$refs.form.submit();
    },
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          // this.$bus.emit('on-submit-files', { files: formModel.document })
          this.onSubmitFiles({ files: formModel.document });
        }
      });
    },
    beforeClose() {
      this.formModel = {
        document: null,
      };
    },
    beforeOpen() {
      this.schema = formSchema(this);
    },
    importExcelHandler(importedFile, uploadStatus) {
      const response = new InvoiceProxy().importExcel(importedFile, uploadStatus);
      response.then((res) => {
        const SUCCESS_IMPORTED_INVOICES = res.invoices_uploaded_successfully && res.invoices_uploaded_successfully.length > 0;
        const DUPLICATED_INVOICES = res.invoices_already_exist && res.invoices_already_exist.length > 0;
        const VERIFY_INVOICES = res.invoices_reconciliation && res.invoices_reconciliation.length > 0;
        if (SUCCESS_IMPORTED_INVOICES || DUPLICATED_INVOICES || VERIFY_INVOICES) {
          setTimeout(() => {
            this.$router.push({ name: 'main.inconsistency', query: this.$route.query }).catch(() => { });
            this.$nextTick(() => {
              this.$modal.show('invoice-import-result-modal', { model: res });
            });
          }, 500);
        }
      }, (err) => {
        this.$nextTick(() => {
          this.$modal.show('invoice-import-error-modal', err);
        });
      });
      return response;
    },
    uploadInvoiceFilesHandler(files) {
      const response = new InvoiceProxy().upload(files, this.uploadStatus);
      response.then((res) => {
        const HAS_SUCCESS_INVOICES = res.invoices && res.invoices.length > 0;
        const HAS_ERROR_INVOICES = res.invoices_error && res.invoices_error.length > 0;
        if (HAS_SUCCESS_INVOICES || HAS_ERROR_INVOICES) {
          this.$modal.show('invoice-upload-modal', { params: res });
          this.$nextTick(() => {
            this.loadInvoices();
          });
        }
      });
      return response;
    },
    onSubmitFiles(payload) {
      this.files = payload.files;
      if (this.files.length === 0) {
        return;
      }
      this.uploadStatus.uploading = true;

      const countInterval = setInterval(() => {
        this.uploadStatus.count++;
      }, 1000);
      let uploadPromise;
      const IS_IMPORT_EXCEL = this.files.length === 1 && this.files[0].name.indexOf('.xls') > -1;
      if (IS_IMPORT_EXCEL) {
        uploadPromise = this.importExcelHandler(this.files[0], this.uploadStatus);
      } else {
        uploadPromise = this.uploadInvoiceFilesHandler([...this.files], this.uploadStatus);
      }
      uploadPromise.then(() => {
        setTimeout(() => {
          this.uploadStatus.uploading = false;
        }, 500);
        clearInterval(countInterval);
        this.uploadStatus.count = 0;
        this.$bus.emit('on-actions-success');
      }).catch(() => {
        setTimeout(() => {
          this.uploadStatus = {
            count: 0,
            uploading: false,
            percentCompleted: 0,
          };
        }, 500);
      }).finally(() => {
        this.$refs.modal.close();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#import-invoice-modal {
  .btn-download {
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #E9EFFD !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/import-invoice-form-modal.vue